import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, theme, Typo } from '../../../ui';
import { toRgba } from '../../../ui/theme/colors';
import { currencyFormatter } from '../../../helpers/formatNumbers';
import { media } from '../../../utils/media';
import StatsCard from './StatsCard';

const FlexContainer = styled(Flex)`
  flex-wrap:wrap;
  gap:20px;
  justify-content:center;

  ${media.lessThan('phablet')} {
    flex-direction: column;
  }
`

const MetricsGrid = styled(Flex)`
  // display: flex;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

const MetricCard = styled(Flex)`
  background: ${theme.colors.NEU_0};
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px ${toRgba(theme.colors.NEU_999, 0.1)};
`;

const StatisticsCards = ({sales, invitations, dashboard}) => {
  const { t } = useTranslation();

  const [totalCourses, setTotalCourses] = useState(0);

  useEffect(() => {
    let totalCourses = 0;
    if(sales.salesPerObject){
      sales.salesPerObject.forEach(course => {
        totalCourses += course.salesCount;
      });
    }

    setTotalCourses(totalCourses);

  }, [sales]);

  return (
    dashboard ? 
    <MetricsGrid>
      <MetricCard direction="column" align="center">
        <Typo.ContentSmallHeader color={theme.colors.PRIMARY}>{totalCourses}</Typo.ContentSmallHeader>
        <Typo.Info>{t('insights.soldCourses')}</Typo.Info>
      </MetricCard>
      <MetricCard direction="column" align="center">
        <Typo.ContentSmallHeader color={theme.colors.PRIMARY}>{currencyFormatter(sales?.totalValue, { symbol: '' })}</Typo.ContentSmallHeader>
        <Typo.Info>{t('insights.totalSales')}</Typo.Info>
      </MetricCard>
      <MetricCard direction="column" align="center">
        <Typo.ContentSmallHeader color={theme.colors.PRIMARY}>{invitations.count}</Typo.ContentSmallHeader>
        <Typo.Info>{t('insights.sentInvites')}</Typo.Info>
      </MetricCard>
      
    </MetricsGrid>
    :
    <FlexContainer>
      <StatsCard 
        label={t('insights.soldCourses')}
        value={totalCourses}
        symbolName={'Books'}
      />
      <StatsCard 
        label={t('insights.totalSales')}
        value={currencyFormatter(sales?.totalValue, { symbol: '' })}
        unit={sales?.storeCurrency}
        symbolName={'BarChart'}
      />
      <StatsCard 
        label={t('insights.sentInvites')}
        value={invitations.count}
        symbolName={'Invitation'}
      />
    </FlexContainer>
  );
};

export default StatisticsCards;
